import MaintenanceWorkflowForwardingCheckinEntrySection from "../../../Sections/CheckinEntry";
import MaintenanceWorkflowForwardingDirectiveEntrySectionDiagnosticEntry from "../../../Sections/DirectiveEntry/Entries/DianosticEntry";
import MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection from "../../../Sections/EstablishmentChoiceEntry";

const DiagnosticEntryCompleted = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingDirectiveEntrySectionDiagnosticEntry />

      <MaintenanceWorkflowForwardingCheckinEntrySection />

      <MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection />
    </>
  );
}

export default DiagnosticEntryCompleted;
